export const UNIFIED_AUTH_COOKIE = 'meetmy_iron_session';

export enum PreviewShape {
  Square = 'square',
  Portrait = '3/4',
}
